import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export default function WallOfFameSkeleton() {
  return (
    <div className='p-2.5 h-full'>
      <div className='bg-white h-full shadow-md relative rounded-lg p-4 text-left'>
        <div className='relative'>
          <Skeleton className='w-full h-52 mb-4' />
          {/* <div className='absolute bottom-0 right-0'>
            <Skeleton className='w-12 h-9 mb-4 bg-[#dbcdcd] opacity-75' />
          </div> */}
        </div>
        <Skeleton className='w-full h-6' />
        <Skeleton className='w-full h-4' />
        {/* <Skeleton className='w-full h-4' /> */}
      </div>
    </div>
  );
}
